import { render, staticRenderFns } from "./createBranchModal.vue?vue&type=template&id=b55f4e34&"
import script from "./createBranchModal.vue?vue&type=script&lang=js&"
export * from "./createBranchModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b55f4e34')) {
      api.createRecord('b55f4e34', component.options)
    } else {
      api.reload('b55f4e34', component.options)
    }
    module.hot.accept("./createBranchModal.vue?vue&type=template&id=b55f4e34&", function () {
      api.rerender('b55f4e34', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/branches/components/createBranchModal.vue"
export default component.exports